import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

const useOnBlurComponent = <T extends HTMLElement>(
  onBlur: () => void,
  overrideRef?: RefObject<T | null>,
) => {
  const initialRef = useRef<T>(null);
  const onBlurRef = useRef(onBlur);
  const ref = overrideRef || initialRef;

  // Update the function to make sure it is always up to date
  useEffect(() => {
    onBlurRef.current = onBlur;
  }, [onBlur]);

  useEffect(
    () => () => {
      // Call the function on unmount
      onBlurRef.current();
    },
    [],
  );

  const handleBlur = () => {
    // Check the newly focused element in the next tick of the event loop
    setTimeout(() => {
      // Check if the new activeElement is not topic input
      if (
        !ref.current?.contains(document.activeElement) &&
        !document.getElementById('popup-root')?.contains(document.activeElement)
      ) {
        onBlur();
      }
    }, 0);
  };

  return {
    ref,
    handleBlur,
  };
};

export default useOnBlurComponent;
